module.exports = __webpack_public_path__ + "static/media/user-protection-error.67c80f91.svg";